/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description: Module for Top Bar

Author: Deimos Space UK

Version: 1.0
*/
import React from "react";
import { Col, Row } from "reactstrap";
import ProfileDropdown from './ProfileDropdown'


const TopBar = ({ children }) => {
	const user = JSON.parse(sessionStorage.getItem('user'))

	const pressLogout = () => {
		sessionStorage.removeItem('user')
		window.location = process.env.REACT_APP_SERVER_URL+"/logout"
	}

	const ProfileMenus = [
		{
			label: 'Logout',
			icon: 'mdi mdi-logout',
			redirectTo: process.env.REACT_APP_SERVER_URL+"/logout",
		},
	];
	return (
		<>
			<div className={`navbar-custom `} style={{ zIndex: 2, display: 'flex', alignContent: 'center', justifyContent: 'flex-end' }}>
				<Row style={{ display: 'flex', alignContent: 'center' }}>
					<Col>
						{children}
					</Col>
					<ul className="list-unstyled topbar-menu float-end mb-0">
					<li className="dropdown notification-list">
                            <ProfileDropdown
                                menuItems={ProfileMenus}
                                username={user.name}
                                userTitle={user.email}
								logout={pressLogout}
                            />
                        </li>
                    </ul>
					
				</Row>
			</div>
		</>
	);
}
export default TopBar
